"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.CopyIcon = function () { return (react_1.default.createElement("svg", { viewBox: "0 0 16 16", width: "16px", height: "16px" },
    react_1.default.createElement("g", null,
        react_1.default.createElement("rect", { width: "16", height: "16", fill: "none" }),
        react_1.default.createElement("rect", { width: "16", height: "16", fill: "none" }),
        react_1.default.createElement("rect", { x: "1", y: "6", width: "10", height: "10", fill: "#4997C7" }),
        react_1.default.createElement("rect", { x: "2", y: "7", width: "8", height: "8", fill: "#FFFFFF" }),
        react_1.default.createElement("polygon", { points: "14 1 13 1 13 0 7 0 7 1 6 1 5 1 5 2 5 5 6 5 6 2 7 2 7 3 13 3 13 2 14 2 14 12 12 12 12 13 14 13 15 13 15 12 15 2 15 1 ", fill: "#7E7E7E" }),
        react_1.default.createElement("polygon", { points: "13 2 13 3 12 3 7 3 7 2 6 2 6 3 6 5 7 5 12 5 12 12 13 12 14 12 14 2 ", fill: "#FFFFFF" })))); };
//# sourceMappingURL=CopyIcon.js.map